import React from 'react';
import { Transition } from 'react-transition-group';
import { func, node, number, object } from 'prop-types';

AnimationWrapper.propTypes = {
  children: node.isRequired,
  duration: number.isRequired,
  defaultStyle: object.isRequired,
  transitionStyles: object.isRequired,
  onExited: func,
};

export default React.memo(AnimationWrapper);

function AnimationWrapper({
  show,
  children,
  duration = 500,
  defaultStyle,
  transitionStyles,
  onExited,
  onEntered,
}) {
  return (
    <Transition
      in={show}
      timeout={duration}
      onExited={onExited}
      onEntered={onEntered}
    >
      {(state) => (
        <div
          style={{
            ...defaultStyle,
            ...transitionStyles[state],
          }}
        >
          {children}
        </div>
      )}
    </Transition>
  );
}
